<template>
  <div>

    <base-header class="pb-0 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12"  md="6"  lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">eSIM QrCode</h6> &nbsp;
        </b-col>
        <b-col cols="12" md="6" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col xl="6">
          <b-input-group size="lg">
            <template #prepend>
              <b-button class="iccid-width ps" style="cursor: default;" variant="primary">ICCID</b-button>
            </template>
            <b-form-input
              data-cy="e-sim-qr-search-input" 
              id="iccid" 
              type="text" 
              v-model="iccid"
            ></b-form-input>
            <b-input-group-append>
              <b-button 
                data-cy="e-sim-qr-search-btn"
                size="lg" 
                variant="success" 
                title="Search" 
                v-on:click="loadPageData"
              >
                <i class="fa fa-search"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col xl="6"></b-col>
      </b-row>

      <b-row v-if="submitLoading" class="text-center">
        <b-col cols="12">
          <b-card no-body>
            <b-card-body>
              <b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="!hasData && !submitLoading">
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <div align="center">Please enter a valid iccid that exists in the system.</div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="hasData">
        <b-col xl="12">

          <b-card>
            <template #header>
              <i class="fa fa-qrcode"></i>&nbsp;<b>Profile Sent</b>
            </template>
            <b-card-text>
              <p>
                The profile was linked to the customer device via the eid (eUICC).<br>
              </p>
              <p>
                Inform the customer to go to Settings > Mobile > Add data plan. The new profile will be available by
                clicking “New data plan”.<br>
                If the profile fails to load within 5 minutes, ask the user to turn their device on and off. This will
                trigger a notifications to install the profile automatically.<br>
                Alternatively, use the QR code below to install the profile.<br>
              </p>
            </b-card-text>
          </b-card>

          <b-card>
            <template #header>
              <i class="fa fa-qrcode"></i>&nbsp;<b>QR code is ready</b>
            </template>
            <b-card-text>
              <table v-if="showQrcode"
                     bgcolor="#d3d3d3"
                     cellpadding="25"
                     width="100%"
                     style="display: block; overflow-x: scroll;"
              >
                <tr>
                  <td rowspan="4"
                      width="160"
                  ><img id="qrcode" data-cy="e-sim-qr-code"/></td>
                  <td>
                    <table width="100%" bgcolor="#ffffff" cellpadding="5" cellspacing="0" border="0" color="#000000">
                      <tr style="border-bottom: 1px solid #d3d3d3!important;color:#000000;">
                        <td>ICCID</td>
                        <td style="float: right;">
                          <div><img id="barcode"/></div>
                        </td>
                      </tr>
                      <tr style="border-bottom: 1px solid #d3d3d3!important;color:#000000;">
                        <td>IMSI</td>
                        <td style="text-align:right!important;">{{ imsi }}</td>
                      </tr>
                      <tr bgcolor="#d3d3d3">
                        <td colspan="2">&nbsp;</td>
                      </tr>
                      <tr style="border-bottom: 1px solid #d3d3d3!important;color:#000000;">
                        <td>SM-DP+</td>
                        <td style="text-align:right!important;">{{ smdp }}</td>
                      </tr>
                      <tr style="border-bottom: 1px solid #d3d3d3!important;color:#000000;">
                        <td>Activation code</td>
                        <td style="text-align:right!important;">{{ activation }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </b-card-text>
          </b-card>

        </b-col>
      </b-row>

    </base-header>

  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import authService from "@/common/api-services/auth-service";
import initService from '../../../common/api-services/init-service';
// Require the package
const QRCodeLib = require('qrcode')
const JsBarcode = require('jsbarcode');

export default {
  components: {
    RouteBreadCrumb,
  },
  data() {
    return {
      ps: 'background-color:rgba(94,114,228);color:#FFFFFF;width:150px',
      qrCddeData: '',
      showQrcode: true,
      hasData: false,
      hasAls: false,
      eid: '',
      iccid: '',
      imsi: '',
      smdp: 'smdp.io',
      activation: '',
      qrcode: null,
      barcode: null,
      //setup for alert
      alertShow: false,
      alertVariant: 'success',
      alertMessage: '',
      submitLoading: false,
    }
  },
  mounted() {
    document.title = 'eSIM - QR Code';
        //don't do anything unless the user has access
    if (!this.noAccess) {
      if (this.$route.query.iccid!=='' && typeof this.$route.query.iccid !== 'undefined') {
        this.iccid = this.$route.query.iccid;
      } else {
        this.readCache();
        this.loadPageData();
      }
    } else {
      this.$router.push('/restricted')
    }
  },
  computed: {
		noAccess() {
			// Determine access based on menu link configuration
      // console.log(this.$route.path.split(':')[0])
      // console.log(this.$route.query)
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$route.path.split(':')[0] + ':id');

			if (!link) {
        // console.log('no link found')
				return true;
			} else {
        // console.log('link found', link)
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		}
	},
  methods: {

    readCache() {
      //get the last saved filter criteria
      let search = localStorage.getItem(this.$route.name);
      // console.log('reading search:',search);
      if (search) {
        search = JSON.parse(search);
        if (search.iccid)
          this.iccid = search.iccid;
      }
    },

    writeCache() {
      //set to current filter criteria
      let search = {
        iccid: this.iccid,
      };
      // console.log('writing search:',search);
      localStorage.setItem(this.$route.name, JSON.stringify(search));
    },

    async loadPageData() {
      this.submitLoading = true;
      this.hasData = false;
      try {
        if (!this.iccid || this.iccid.length !== 20) {
          throw new Error('Invalid ICCID.');
        } else {
          //first:  API lookup data
          await eSimDashboardService.getProfile(this.iccid).then(res => {
            //console.log('res:', res);
            this.imsi = res.data.imsi;
            //this.smdp = res.data.smdpAddress;
            this.activation = res.data.matchingId;
            this.hasData = true;
            if (res.data.smdsAddress === "https://sq-carrier.apple.com/gsma/rsp2/es12") {
              this.hasAls = true;
            } else {
              this.hasAls = false;
            }
            this.eid = res.data.profileOwner;
          });
          //Create the qrcode
          let qrdata = 'LPA:1$' + this.smdp + '$' + this.activation;
          QRCodeLib.toDataURL(qrdata, function (err, url) {
            var img = document.getElementById('qrcode')
            img.src = url
          });
          //create barcode
          JsBarcode("#barcode", this.iccid, {
            format: "code128",
            lineColor: "#000000",
            width: 1.5,
            height: 15,
            displayValue: true
          });
        }
        authService.setActivityLog('ESIM:showQrcode', 'show qrcode OK: '+this.iccid, 0);
      } catch (e) {
        authService.setActivityLog('ESIM:showQrcode', JSON.stringify(e), 1);
        //this.showToasterMsg('Error: Unable to create qrCode. Detail: '+e.message, true, 'danger');
        this.hasData = false;
      } finally {
        this.submitLoading = false;
      }
      this.writeCache();
    },


  },
}
</script>
